<template>
  <div
    class="navcard"
    :class="{ navcard_active: isActive }"
    :data-tst="dataTst"
    @click="e => $emit('click', e)"
  >
    <div
      v-if="hasIcon"
      class="navcard_icon csst"
    >
      <slot name="icon">
        <i
          class="mdi"
          :class="item.icon"
        />
      </slot>
      <div
        v-if="hasTooltip"
        class="csst_content text-nowrap clr-white"
        style="
          align-self: flex-start;
          position: fixed;
          margin: var(--tooltip-margin);
          transform: var(--tooltip-transform);
        "
        v-html="item.title"
      ></div>
    </div>
    <div
      v-if="hasText"
      class="navcard_text"
    >
      <div
        v-if="hasTitle"
        class="navcard_title"
      >
        <div
          v-if="hasTitleIcon"
          class="navcard_icon"
        >
          <slot name="icon">
            <i
              class="mdi"
              :class="item.icon"
            />
          </slot>
        </div>
        <slot name="title">
          {{ item.title }}
        </slot>
      </div>
      <div
        v-if="hasSub"
        class="navcard_sub"
      >
        <slot name="sub">
          {{ item.sub }}
        </slot>
      </div>
    </div>
    <div
      v-if="item.tag && hasTag"
      class="navcard_tag"
    >
      <slot>
        {{ item.tag }}
      </slot>
    </div>
    <div
      v-if="item.badge && hasBadge"
      class="navcard_badge"
    >
      {{ item.badge }}
    </div>
    <slot name="after"></slot>
  </div>
</template>

<script>
export default {
  name: 'NavCard',
  props: {
    item: {
      default: () => ({}),
    },
    isActive: Boolean,
    hasIcon: { type: Boolean, default: true },
    hasText: { type: Boolean, default: true },
    hasTitle: { type: Boolean, default: true },
    hasSub: { type: Boolean, default: true },
    hasTag: { type: Boolean, default: true },
    hasBadge: { type: Boolean, default: true },
    hasTitleIcon: Boolean,
    hasTooltip: Boolean,
    dataTst: String,
  },
  emits: ['click'],
  data() {
    return {}
  },
  methods: {
    handleRouteClick(item) {
      this.$router.push({ name: item.pathName, query: item.query || {} })
    },
  },
}
</script>

<style lang="scss">
.navcard_router-link_active {
  --clr-back: var(--clr-back-active) !important;
  --clr-icon: var(--clr-icon-active) !important;
  --clr-title: var(--clr-title-active) !important;
  --clr-sub: var(--clr-sub-active) !important;
}
.router-link-active {
  .navcard_router-link:not(.router-link-active-ignore) {
    @extend .navcard_router-link_active;
  }
}
.router-link-exact-active {
  .navcard_router-link:not(.router-link-active-ignore) {
    @extend .navcard_router-link_active;
  }
}
.router-link-active:not(.only-exact-active) {
  .navcard_router-link:not(.router-link-active-ignore) {
    @extend .navcard_router-link_active;
  }
}
</style>

<style lang="scss" scoped>
.navcard {
  --height: auto;
  --width: auto;
  --padding: 1rem;
  --radius: 4px;
  --cursor-hover: pointer;

  --tooltip-transform: translate(0, 0);
  --tooltip-margin: 0rem 0 0 2.5rem;

  --clr-back: var(--clr-black-1);
  --clr-back-hover: var(--clr-black-1-3);
  --clr-back-active: var(--clr-black-1-3);

  --clr-text: var(--clr-white-0);
  --clr-text-hover: var(--clr-primary);
  --clr-text-active: var(--clr-primary);

  --clr-title: var(--clr-text);
  --clr-title-hover: var(--clr-text-hover);
  --clr-title-active: var(--clr-text-active);
  --title-grid-gap: 0.25rem;
  --title-size: 1rem;
  --title-weight: 500;
  --title-transform: auto;

  --clr-icon: var(--clr-text);
  --clr-icon-hover: var(--clr-text-hover);
  --clr-icon-active: var(--clr-text-active);
  --icon-size: 1.5rem;
  --icon-font-size: var(--icon-size);
  --icon-transform: none;
  --icon-inset: auto;
  --clr-icon-back: transparent;
  --icon-radius: 0px;
  --icon-align-items: flex-start;
  --icon-justify-content: flex-start;

  --padding-text: 0 0 0 1rem;
  // --padding-title: 0;
  --padding-sub: 0;

  --clr-sub: var(--clr-black-6);
  --clr-sub-hover: var(--clr-black-9);
  --clr-sub-active: var(--clr-black-9);
  --sub-size: 0.875rem;
  // --sub-size: 0.8rem;
  // --sub-weight: 500;
  --sub-weight: 400;
  --sub-transform: unset;

  --clr-tag: var(--clr-white-0);
  --clr-tag-back: var(--clr-grey-2);
  --tag-size: 0.8rem;
  --tag-weight: 500;
  --tag-padding: 0 0.25rem;
  --tag-height: unset;
  --tag-top: 0.5rem;
  --tag-right: 0.5rem;

  --clr-badge: var(--clr-white-0);
  --clr-badge-back: var(--clr-primary);
  --badge-size: 1.25rem;

  --clr-after: transparent;
  --clr-after-hover: transparent;
  --clr-after-active: var(--clr-primary);

  height: var(--height);
  width: var(--width);
  padding: var(--padding);
  background: var(--clr-back);
  border-radius: var(--radius);

  display: flex;
  align-items: center;
  position: relative;

  &_menu-trigger {
    --radius: 0;
    --padding: 0 0.75rem;
    --height: 100%;
    --padding-text: 0 0 0 0.5rem;
    --icon-size: 1.5rem;
    // --title-transform: uppercase;
  }
  &_menu {
    --icon-size: 1.5rem;
  }
  &_dashboard {
    --icon-size: 3.5rem;
    --title-size: 1.25rem;
    --sub-size: 1rem;
    --padding: 1.5rem 2rem;
    --padding-text: 0 1rem;
    --radius: 8px;
    --icon-align-items: center;
    --icon-justify-content: center;
    transition: transform 0.22s;
    &:hover {
      background: var(--clr-black-1-3) !important;
      z-index: 3;
      transform: translate(0, -2px);
    }
  }
  &_dashboard_small {
    --icon-size: 2rem;
    --title-size: 1rem;
    --padding: 1rem 1.25rem;
    --padding-text: 0 1rem;
    --radius: 4px;
    transition: transform 0.22s;
    &:hover {
      background: var(--clr-black-1-3) !important;
      z-index: 3;
      transform: translate(0, -2px);
    }
  }
  &_dashboard-v2 {
    --icon-size: 2.875rem;
    --icon-font-size: 2rem;
    --icon-inset: auto;
    // --clr-icon-back: red;
    --icon-radius: 8px;
    --clr-icon: var(--clr-back);

    --title-size: 1.5rem;
    --title-weight: 600;
    --sub-size: 1rem;
    --padding: 1.5rem 2rem;
    // --padding-text: 0;
    --padding-text: 1rem 0 0 0;
    --radius: 8px;
    transition: transform 0.22s;

    flex-direction: column;
    align-items: flex-start;
    // justify-content: flex-start;
    // line-height: 1;
    // text-align: center;
    &:hover {
      --clr-back: var(--clr-black-1-3) !important;
      z-index: 3;
      transform: translate(0, -2px);
    }
  }
  &_pyramid {
    --radius: 0;
    --icon-size: 1.5rem;
    --title-size: 0.8rem;
    --padding: 0 0.5rem;
    --padding-text: 0.25rem 0 0 0;

    --clr-icon-active: var(--clr-primary);
    --clr-title-active: var(--clr-primary);
    flex-direction: column;
    justify-content: center;
    line-height: 1;
    text-align: center;
  }
  &_reversed_l {
    --clr-text: var(--clr-grey-2);
    --icon-inset: -0.125rem auto auto -0.175rem;
    --padding-text: 0;
    .navcard_title {
      display: flex;
      align-items: flex-end;
      grid-gap: var(--title-grid-gap);
    }
  }
  &_inline {
    --padding: 0 0.75rem;
    --height: 4rem;
    --clr-text: var(--clr-grey-2);
    --padding-text: 0 0 0 0.75rem;
    .navcard_title {
      display: flex;
      align-items: flex-end;
      grid-gap: var(--title-grid-gap);
    }
  }
  &_small {
    --icon-size: 1.5rem;
    --title-size: 0.875rem;
    --sub-size: 0.8rem;
    --padding: 0.5rem 1rem;
    --padding-text: 0 0.5rem;
  }

  &_appbar {
    --height: 2.5rem;
    --icon-size: 1.25rem;
    --title-size: 0.875rem;
    --padding-text: 0 0 0 0.75rem;
    --radius: 0;
    white-space: nowrap;
  }

  &_centered {
    .navcard_text {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  &_active {
    &:not(.navcard_not-active) {
      --clr-back: var(--clr-back-active) !important;
      --clr-icon: var(--clr-icon-active) !important;
      --clr-title: var(--clr-title-active) !important;
      --clr-sub: var(--clr-sub-active) !important;
      --clr-after: var(--clr-after-active) !important;
    }
  }
  &_icon {
    background: var(--clr-icon-back);
    border-radius: var(--icon-radius);
    font-size: var(--icon-font-size);
    color: var(--clr-icon);
    fill: var(--clr-icon);
    height: var(--icon-size);
    width: var(--icon-size);
    inset: var(--icon-inset);
    transform: var(--icon-transform);
    line-height: 1;
    position: relative;
    display: flex;
    align-items: var(--icon-align-items);
    justify-content: var(--icon-justify-content);
    // padding: var(--padding-title);
    flex-shrink: 0;
    svg {
      width: 100%;
      height: 100%;
    }
  }
  &_text {
    position: relative;
    padding: var(--padding-text);
    width: 100%;
  }
  &_title {
    color: var(--clr-title);
    font-size: var(--title-size);
    font-weight: var(--title-weight);
    text-transform: var(--title-transform);
    padding: var(--padding-title);
    // display: flex;
    // align-items: flex-end;
    // grid-gap: var(--title-grid-gap);
  }
  &_sub {
    color: var(--clr-sub);
    font-size: var(--sub-size);
    font-weight: var(--sub-weight);
    text-transform: var(--sub-transform);
    padding: var(--padding-sub);
  }
  &_tag {
    position: absolute;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--clr-tag);
    background: var(--clr-tag-back);
    padding: var(--tag-padding);
    height: var(--tag-height);
    border-radius: 4px;
    top: var(--tag-top);
    right: var(--tag-right);
    font-size: var(--tag-size);
    font-weight: var(--tag-weight);
  }
  &_badge {
    position: absolute;
    color: var(--clr-badge);
    height: var(--badge-size);
    width: var(--badge-size);
    background: var(--clr-badge-back);
    border-radius: 50%;
    top: -0.5rem;
    right: -0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

@media (hover: hover) and (pointer: fine) {
  .navcard {
    &:hover {
      cursor: var(--cursor-hover);
      --clr-back: var(--clr-back-hover) !important;
      --clr-icon: var(--clr-icon-hover) !important;
      --clr-title: var(--clr-title-hover) !important;
      --clr-sub: var(--clr-sub-hover) !important;
      --clr-after: var(--clr-after-hover) !important;
    }
    &_icon {
      &:hover {
        // cursor: pointer;
        --clr-icon: var(--clr-icon-hover) !important;
      }
    }
    &_title {
      &:hover {
        // cursor: pointer;
        --clr-title: var(--clr-title-hover) !important;
      }
    }
    &_sub {
      &:hover {
        // cursor: pointer;
        --clr-sub: var(--clr-sub-hover) !important;
      }
    }
  }
}
</style>
